const mutations = {
    /*获取可视区域高度*/
    GET_CLIENT_HEIGHT(state, clientH){
        state.clientH = clientH;
    },
    GET_AMPLIFY_IMAGE_ARR(state, imageObj){// 获取需要放大的图片数组
        state.imageAmplifyObj = imageObj;
    },
    /*发布文章模块mutations*/
    GET_ARTICLE_LIST(state, articleList){
        state.articleList = articleList;
    },
    deleteArticleTableDataRow(state, payload){//文章发布模块，删除文件
        state.contentData.splice(payload.row, 1);
    },
    /*远程会诊模块*/
    //获取当前选取的会诊列表（我发起的，我收到的，取消，已结束---）
    GET_CURRENT_CONSULT_LIST(state, list){
        state.currentConsultList = list;
    },
    //获取当前会诊单
    GET_CURRENT_CONSULT(state, consult){
        state.currentConsult = consult;
    },
    //获取需要打印的会诊详情
    GET_PRINT_DETAIL(state, detail){
        state.printDetail = detail;
    },
    //获取当前发起会诊类型
    GET_CONSULT_TYPE(state, consoultType){
        state.consultType = consoultType;
    },
    //获取邀请医生列表
    GET_INVITE_DOC_LIST(state, inviteVoList){
        state.inviteVoList = inviteVoList;
    },
    //获取医助端视频问诊和会诊侧边栏顶部标题
    GET_SIDEBAR_TITLE(state, title){
        state.sidebarTitle = title;
    },
    /*登录*/
    GET_USER_INFO(state, loginInfo){
        state.userInfo = loginInfo;
        state.isLogin = true;
    },
    /*患者ID*/
    GET_PATIENT_ID(state, patientId){
    state.currentPatientId = patientId;
},
    /*设置*/
    //个人业务设置
    /*SET_BUSINESS_SETTING_VIDEO_STATE(state, setting){//是否开通视频问诊
        state.docVideoConsultStatus = setting;
    },
    SET_BUSINESS_SETTING_VIDEO_PRICE(state, price){//视频问诊费用
        state.docVideoConsultPrice = price;
    },*/
    SET_BUSINESS_SETTING_VIDEO_MOVE(state, move){//是否开通视频问诊滑块开关
        state.isMoveVideo = move;
    },
    SET_BUSINESS_SETTING_PIC_MOVE(state, move){//是否开通图文咨询滑块开关
        state.isMovePic = move;
    },
    GET_SET_UP_CLICK_NAME(state, setUpClickName){//点击设置中心侧边栏item名字
        state.setUpClickName = setUpClickName
    },
    /*SET_BUSINESS_SETTING_PIC_STATE(state, setting){//是否开通图文咨询
        state.docPicConsultStatus = setting;
    },
    SET_BUSINESS_SETTING_PIC_PRICE(state, price){//图文咨询费用
        state.docPicConsultPrice = price;
    },*/
      //绑定手机修改

    /*点击首页侧边栏事件*/
    CHANGE_SIDE_ITEM(state, payload){
        state.clickName = payload;
        switch (payload){
        	case "wlmz":
                state.isGetNewMsg_wdhz = false;// 消除红点
        	    state.routerPath="网络门诊";
        		break;
            case "ychz":
                state.isGetNewMsg_ychz = false;// 消除红点
        	    state.routerPath="远程会诊";
        		break;
        	default:
        		break;
        }
    },
    /*回话mutations*/
    GET_MESSAGE_LIST(state, msgList){//获取从服务器消息
        state.messageList = msgList;
    },
    GET_PAT_MESSAGE_LIST(state, patMessageList){//获取从服务器医患关系聊天消息列表
        state.patMessageList = patMessageList;
    },
    GET_PUSH_MSG_CONSULT_ID(state, pushMsgConsultId){// 聊天回复推送的consultId
        state.pushMsgConsultId = pushMsgConsultId;
    },
    GET_PUSH_MSG_FOLLOW_ID(state, pushMsgFollowtId){// 医患关系聊天回复推送的followId
        state.pushMsgFollowId = pushMsgFollowtId;
    },
    /*我的患者模块*/
    GET_PAT_DETAIL(state, patDetail){//获取点击的患者详情
        state.patDetail = patDetail;
    },
    GET_PAT_ID(state, patId){//获取患者id
        state.patId = patId;
    },
    GET_MEDICAL_HISTORY_ITEM(state, sysMedicalHistroyItem){//获取需要编辑修改的诊疗记录项
        state.sysMedicalHistroyItem = sysMedicalHistroyItem;
    },
    GET_MEDICAL_EDIT_TYPE(state, editType){//上传修改诊疗记录弹出窗类型判断，add表示上传，edit表示编辑（需要把sysMedicalHistroyItem传入）
        state.medicalEditType = editType;
    },
    CHECK_FOLLOW_ID_LIST(state, checkFollowIdList){//我的患者群发消息时，所选择的患者followId
        state.checkFollowIdList = checkFollowIdList;
    },
    IS_OPEN_ARTICLE_LIST_BOX(state, isOpenArticleListBox){// 是否打开文章列表
        state.isOpenArticleListBox = isOpenArticleListBox;
    },
    GET_PUSH_POINT_MY_PATIENT_ARR(state, pushPointFollowId){// 当前推送的会话聊天followId数组(会有多个聊天推送), 用于显示列表中的红点
        if(state.pushPointMyPatientArr.indexOf(pushPointFollowId) === -1){// 判断是否已经在数组中
            state.pushPointMyPatientArr.push(pushPointFollowId);
        }
    },
    REMOVE_PUSH_POINT_MY_PATIENT_ARR(state, removePointFollowId){// 左侧聊天列表中点击某项，删除红点
        if(state.pushPointMyPatientArr.indexOf(removePointFollowId) !== -1) {// 判断是否已经在数组中
            let index = state.pushPointMyPatientArr.indexOf(removePointFollowId);
            state.pushPointMyPatientArr.splice(index, 1);
        }
    },
    /*图文咨询模块*/
    GET_CURRENT_PATIENT_TAB(state, tabName){// 获取当前点击列表处理按钮所在tab页码
        state.currentPatientTab = tabName;
    },

    /**
     * 推送模块
     *
     */
    ENTER_VIDEO_LIST(state,enterVideoList){//进入视频的订单ID列表
        state.enterVideoList = enterVideoList;
    },
    ENTER_VIDEO_DDID(state,enterVideoDdid){//进入视频的订单Id
        state.enterVideoList.push(enterVideoDdid);
    },
    IS_OPEN_MSG_LIST_BOX(state, isOpenMsgListBox) {// 是否打开消息盒子
        state.isOpenMsgListBox = isOpenMsgListBox;
    },
    IS_GET_NEW_MSG_YQYS(state, isGetNewMsg_yqys){
       state.isGetNewMsg_yqys = isGetNewMsg_yqys;
    },
    GET_ALL_MSG_BOX_LIST(state, allMsgBoxList) {// 获取消息盒子列表
        state.allMsgBoxList = allMsgBoxList;
    },
    GET_ALL_MSG_BOX_LIST_COUNTS(state, allMsgBoxListCounts) {// 获取消息盒子未读数
        state.allMsgBoxListCounts = allMsgBoxListCounts;
    },
    CHANGE_MSG_BOX_LIST_COUNTS(state, isAdd) {// 获取消息盒子未读数
        if(isAdd == true){
            state.allMsgBoxListCounts += 1;
        }else {
            state.allMsgBoxListCounts = state.allMsgBoxListCounts > 0 ? (state.allMsgBoxListCounts - 1) : 0;
        }
    },
    GET_END_CONSULT_ID(state, endConsultId) {// 获取当前结束的id
        state.endConsultId = endConsultId;
    },
    GET_REFRESH_CONSULT_ID(state, refreshConsultId){// 获取当前需要刷新的id
        state.refreshConsultId = refreshConsultId;
    },
    //图文咨询
    IS_GET_NEW_MSG_TWZX(state, isGetNewMsg_twzx){// 图文咨询侧边栏红点
        state.isGetNewMsg_twzx = isGetNewMsg_twzx;
    },
    IS_GET_NEW_MSG_TWZX_DCL(state, isGetNewMsg_twzx_dcl){//是否获取到新图文咨询
        state.isGetNewMsg_twzx_dcl = isGetNewMsg_twzx_dcl;
    },
    IS_GET_NEW_MSG_TWZX_DHF(state, isGetNewMsg_twzx_dhf){//是否获取到新图文咨询待回复
        state.isGetNewMsg_twzx_dhf = isGetNewMsg_twzx_dhf;
    },
    IS_GET_NEW_MSG_TWZX_YWC(state, isGetNewMsg_twzx_ywc){//是否获取到新文咨询已结束
        state.isGetNewMsg_twzx_ywc = isGetNewMsg_twzx_ywc;
    },
    IS_GET_NEW_MSG_TWZX_YQX(state, isGetNewMsg_twzx_yqx){//是否获取到新文咨询已结束
        state.isGetNewMsg_twzx_yqx = isGetNewMsg_twzx_yqx;
    },
    //我的患者推送
    IS_GET_NEW_MSG_WDHZ(state, isGetNewMsg_wdhz){// 图文咨询侧边栏红点
        state.isGetNewMsg_wdhz = isGetNewMsg_wdhz;
    },
    //视频问诊
    IS_GET_NEW_MSG_SPWZ(state, isGetNewMsg_spwz){// 视频问诊侧边栏红点
        state.isGetNewMsg_spwz= isGetNewMsg_spwz;
    },
    IS_GET_NEW_MSG_SPWZ_DCL(state, isGetNewMsg_spwz_dcl){//是否获取到新视频问诊
        state.isGetNewMsg_spwz_dcl = isGetNewMsg_spwz_dcl;
    },
    IS_GET_NEW_MSG_SPWZ_BCZL(state, isGetNewMsg_spwz_bczl){// 补充资料推送
        state.isGetNewMsg_spwz_bczl = isGetNewMsg_spwz_bczl;
    },
    IS_GET_NEW_MSG_SPWZ_DWZ(state, isGetNewMsg_spwz_dwz){// 获取新待问诊消息
        state.isGetNewMsg_spwz_dwz = isGetNewMsg_spwz_dwz;
    },
    IS_GET_NEW_MSG_SPWZ_YWC(state, isGetNewMsg_spwz_ywc){// 完成视频问诊推送
        state.isGetNewMsg_spwz_ywc = isGetNewMsg_spwz_ywc;
    },
    IS_GET_NEW_MSG_SPWZ_YQX(state, isGetNewMsg_spwz_yqx){// 完成视频问诊推送
        state.isGetNewMsg_spwz_yqx = isGetNewMsg_spwz_yqx;
    },

    //远程会诊
    IS_GET_NEW_MSG_YCHZ(state, isGetNewMsg_ychz){// 视频问诊侧边栏红点
        state.isGetNewMsg_ychz= isGetNewMsg_ychz;
    },
    IS_GET_NEW_MSG_YCHZ_WFQ(state, isGetNewMsg_ychz_wfq){// 发起消息推送
        state.isGetNewMsg_ychz_wfq = isGetNewMsg_ychz_wfq;
    },
    IS_GET_NEW_MSG_YCHZ_WSD(state, isGetNewMsg_ychz_wsd){// 收到会诊推送
        state.isGetNewMsg_ychz_wsd = isGetNewMsg_ychz_wsd;
    },
    IS_GET_NEW_MSG_YCHZ_YWC(state, isGetNewMsg_ychz_ywc){// 完成会诊推送
        state.isGetNewMsg_ychz_ywc = isGetNewMsg_ychz_ywc;
    },
    IS_GET_NEW_MSG_YCHZ_YQX(state, isGetNewMsg_ychz_yqx){// 取消会诊推送
        state.isGetNewMsg_ychz_yqx = isGetNewMsg_ychz_yqx;
    },
    IS_GET_NEW_MSG_YCHZ_BCZL(state, isGetNewMsg_ychz_bczl){// 补充了资料推送
        state.isGetNewMsg_ychz_bczl = isGetNewMsg_ychz_bczl;
    },
    IS_GET_NEW_MSG_YCHZ_YQBC(state, isGetNewMsg_ychz_yqbc){// 要求补充资料推送
        state.isGetNewMsg_ychz_yqbc = isGetNewMsg_ychz_yqbc;
    },

    /*会议中心*/
    GET_REFRESH_MT_ID(state, refreshMtId){// 获取当前需要刷新的id
        state.refreshMtId = refreshMtId;
    },
    //会议中心推送
    IS_GET_NEW_MSG_HYZX(state, isGetNewMsg_hyzx){// 视频问诊侧边栏红点
        state.isGetNewMsg_hyzx= isGetNewMsg_hyzx;
    },
    IS_GET_NEW_MSG_HYZX_DCJ(state, isGetNewMsg_ychz_dcj){// 待参加会议推送
        state.isGetNewMsg_ychz_dcj = isGetNewMsg_ychz_dcj;
    },
    IS_GET_NEW_MSG_HYZX_LSHY(state, isGetNewMsg_ychz_lshy){// 历史会议推送
        state.isGetNewMsg_ychz_lshy = isGetNewMsg_ychz_lshy;
    },

};
export default mutations;
